import type { AdminDashboardFunnelStage } from '@workspace/api-backend'

function pct(part: number, whole: number): string {
  if (whole <= 0) return '—'
  return `${Math.round((part / whole) * 100)}%`
}

/**
 * Horizontal funnel: each stage shows a bar relative to the first stage,
 * its absolute count, and the conversion from the previous stage.
 */
export function FunnelList({ stages }: { stages: AdminDashboardFunnelStage[] }) {
  const first = stages[0]?.count ?? 0
  return (
    <div className="space-y-2">
      {stages.map((stage, i) => {
        const prev = i === 0 ? stage.count : (stages[i - 1]?.count ?? 0)
        const width = first > 0 ? Math.max(2, (stage.count / first) * 100) : 0
        return (
          <div key={stage.label}>
            <div className="flex items-baseline justify-between gap-2 text-xs">
              <span className="text-muted-foreground">{stage.label}</span>
              <span className="tabular-nums text-foreground">
                {stage.count.toLocaleString()}
                {i > 0 && (
                  <span className="ml-2 text-muted-foreground/60">{pct(stage.count, prev)}</span>
                )}
              </span>
            </div>
            <div className="mt-1 h-2 rounded-full bg-muted/40">
              <div className="h-2 rounded-full bg-primary/70" style={{ width: `${width}%` }} />
            </div>
          </div>
        )
      })}
    </div>
  )
}
